import { render } from "./Article.vue?vue&type=template&id=57a38104&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import "./Article.vue?vue&type=style&index=0&id=57a38104&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57a38104"

export default script